export const ONLY_POST_MSG_PARTNERS = ['tricycle', 'boribori']

export enum BRIDGE {
  LOGIN = 'flexCollectLogin',
  ENTER = 'flexCollectEnter',
  BROADCAST = 'flexCollectMoveBroadcast',
  BROADCAST_CUSTOM_BUTTON = 'flexCollectBroadcastCustomButton',
  PRODUCT = 'flexCollectMoveProduct',
  TOP_BANNER = 'flexCollectMoveTopBanner',
  CONTENT_BANNER = 'flexCollectMoveContentBanner',
  APPLY_CHECK_NOTIFICATION = 'flexCollectApplyCheckNotification',
  APPLY_NOTIFICATION = 'flexCollectApplyForNotification',
  CANCEL_NOTIFICATION = 'flexCollectCancelForNotification',
  CANCEL_CHECK_NOTIFICATION = 'flexCollectCancelCheckNotification',
  THEME_TYPE_A = 'flexCollectThemeTypeA',
  THEME_TYPE_B = 'flexCollectThemeTypeB',
  CURATION = 'flexCollectClickCuration',
  DOM_RECT = 'flexCollectDOMRect',
}
